import { Modal } from '@iwoca/orion';

import { BusinessDetailsStage } from './Application/BusinessDetailsStage';
import { SellerActions } from './Application/SellerActions';
import { LatestPaymentsTable } from './SpendingLimit/LatestPaymentsTable';
import {
  SpendingLimitsContentSwitcher,
  SpendingLimitsLoading,
} from './SpendingLimit/SpendingLimitsContentSwitcher';
import { useGetSellerCustomerSpendingLimit } from '../../../../api/lending/lapiHooks';
import {
  TApplicationSubStage,
  TCustomerSpendingLimit,
  TSelectedBuyer,
} from '../../Customers.types';
import { SecurityChecksStage } from './Application/SecurityChecksStage';

export const SUB_STAGE_NAME_MAP: Record<TApplicationSubStage, string> = {
  business_type: 'Sign-Up (Business type)',
  business_info: 'Sign-Up (Business info)',
  director_info: 'Sign-Up (Director info)',
  id_check: 'ID check',
  card_details: 'Card details',
  internal_checks: 'Internal checks',
  shareholder_check: 'Major shareholder checks',
  personal_guarantor_check: 'Documents signed',
};

export const CustomerInformationModal = ({
  open,
  onClose,
  selectedBuyer,
}: {
  open: boolean;
  onClose: () => void;
  selectedBuyer: TSelectedBuyer;
}) => {
  const { spendingLimit, loadingSpendingLimit } =
    useGetSellerCustomerSpendingLimit({
      buyerStateKey: selectedBuyer.stateKey,
    });

  const limits: TCustomerSpendingLimit[] = spendingLimit || [];

  const currentStage = selectedBuyer.applicationStage?.value;
  const applicationSubStages = selectedBuyer.applicationSubStages;

  const hasCompletedApplication = currentStage === 'complete';

  if (!currentStage || !applicationSubStages) {
    return null;
  }

  return (
    <Modal
      closeIcon
      headerBar
      id="modal_id"
      isOpen={open}
      onClose={onClose}
      title={selectedBuyer.name}
    >
      {hasCompletedApplication ? (
        <div className="flex flex-col gap-xl">
          {loadingSpendingLimit ? (
            <SpendingLimitsLoading />
          ) : (
            <SpendingLimitsContentSwitcher limits={limits} />
          )}
          <LatestPaymentsTable selectedBuyer={selectedBuyer} />
        </div>
      ) : (
        <div>
          <SellerActions applicationStage={currentStage} />
          <div className="grid grid-cols-[36px_1fr] gap-x-s gap-y-0 px-s py-xl">
            <BusinessDetailsStage
              currentStage={currentStage}
              applicationSubStages={applicationSubStages}
            />
            <SecurityChecksStage
              currentStage={currentStage}
              applicationSubStages={applicationSubStages}
              limitAmount={selectedBuyer.limitAmount}
              limitDuration={selectedBuyer.limitDuration}
            />
          </div>
        </div>
      )}
    </Modal>
  );
};
